import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=745fe0e6&scoped=true"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"
import style0 from "./branch.vue?vue&type=style&index=0&id=745fe0e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745fe0e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('745fe0e6')) {
      api.createRecord('745fe0e6', component.options)
    } else {
      api.reload('745fe0e6', component.options)
    }
    module.hot.accept("./branch.vue?vue&type=template&id=745fe0e6&scoped=true", function () {
      api.rerender('745fe0e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/branch.vue"
export default component.exports